import Button from '@pelckmans/elementis/components/button';
import Pin from '@pelckmans/elementis/icons/pin';
import PinAlt from '@pelckmans/elementis/icons/pin-alt';
import { MouseEvent, useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import PinnedMaterialContext from '../../_contexts/PinnedMaterialContext';

interface SlideSetProps {
  materialId: number;
  type: 'slide-set';
}
interface MaterialProps {
  materialId: string;
  type: 'medialink' | 'user-material';
}

type PinnedMaterialButtonProps = SlideSetProps | MaterialProps;

export default function PinnedMaterialButton({ materialId, type }: PinnedMaterialButtonProps) {
  const { t } = useTranslation();
  const { pinnedMaterialList, togglePinnedMaterial } = useContext(PinnedMaterialContext);

  const [isPinned, setIsPinned] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);

  useEffect(() => {
    setIsPinned(pinnedMaterialList.some(um => um.id === materialId));
  }, [materialId, pinnedMaterialList]);

  const handleButtonClick = async (e: MouseEvent<HTMLButtonElement | HTMLAnchorElement>) => {
    e?.stopPropagation();
    e?.preventDefault();

    if (isSubmitted) return;
    setIsSubmitted(true);
    togglePinnedMaterial(materialId, type);
    setIsSubmitted(false);
  };

  return (
    <Button
      prominence="neutral"
      startIcon={isPinned ? <PinAlt /> : <Pin />}
      aria-label={
        isPinned
          ? t('PAGES.TOC_LEVEL.PINNED_MATERIAL.BUTTON.A11Y_LABEL_UNPIN')
          : t('PAGES.TOC_LEVEL.PINNED_MATERIAL.BUTTON.A11Y_LABEL_PIN')
      }
      onClick={handleButtonClick}
      size="sm"
    />
  );
}
